export enum Sign {
  positive = "pos",
  negative = "neg",
}

export function sign(input: number): Sign {
  return input < 0 ? Sign.negative : Sign.positive;
}
